// extracted by mini-css-extract-plugin
module.exports = {"stepDescription":"StepDescription_stepDescription__17vX8","mask":"StepDescription_mask__3EN3J"};